export const ENVIRONMENT: 'development' | 'production' | 'demo' = 'production'
export const REVISION: string = '5637ad1e4b4d6b5219cc7b5ca9ac8930269ddd31'



// WEBPACK FOOTER //
// ./src/config/environment.ts